import { lighten } from '@material-ui/core/styles/colorManipulator';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import { fade } from '@material-ui/core/styles/colorManipulator';

export const styles = theme => ({
  root: {
    width: '100%',
    // marginTop: theme.spacing(3),
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  editComponent: {
    display: 'none'
  },
  editButton: {
    cursor: 'pointer'
  },
  saveButton: {
    cursor: 'pointer',
    fontSize: '0.8125rem',
    margin: '0pc 6px',
  },
  iconEdit : {
    width: '16px',
    height: '16px',
    cursor: 'pointer',
  },
  imgText:{    
    cursor: 'pointer',
    fontSize: '0.6125rem',
    color: '#3f51b5',
  },
  textField: {
    width: '100%',
  },
  customRoot: {
    width: '100%',
  },
  infoBranch: {
    padding: '10px',
  },
  detailBranch: {
    marginLeft: '8px',
  },
  selectedMenu: {
    '&:focus': {
      backgroundColor: 'transparent',
    }
  },
  // new modify
  tableRowHeight:{
    height:0
  },
  frameTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  infoRecord: {
    fontSize: '0.8rem',
    color: '#546e7a',
    marginTop: '1.6rem'
  },
  buttonOnRow: {
    width: '-webkit-fill-available',
    margin: '0.2rem'
  },
  containerButton:{ 
    display: 'flex'
  },
  tableCellInCollapes: {
    borderBottom: 'none'
  },
});

export const tableHeadStyles = theme => ({
  head : {
    
    fontSize : '14px',
    fontWeight : '450',
    paddingRight : 26,
  },
  headFirst : {
    padding: '0px 12px',
    
    fontSize : '14px',
    fontWeight : '460',
  }
});

export const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  }
});

export const galleryStyle = theme => ({
  root : {
    width : '100%',
    height : '100%',
  },
  listItem : {
    // width : '100%',
    height : '100%',
    boxShadow :'0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);',
    position : 'relative',
  },
  imageItem: {
    minHeight: '5rem',
    width: '100%',
    cursor: 'pointer',
    backgroundSize : 'contain',
    backgroundPosition : 'center',
    backgroundRepeat: 'no-repeat'
  },
  inputImage : {
      display : 'none'
  },
  buttonIcon : {
      width : 64,
      height : 64,       
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
  },
  icon: {
    cursor: 'pointer',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    fontSize: 40,
  },
  buttonHover: {
    width : 36,
    height : 36,  
    margin : '0px 5px'     
  },
  iconHover: {
    cursor: 'pointer',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    fontSize: 24,
  },  
  modalImage: {
    position: 'absolute',
    width : '60%',
    paddingTop : '33.75%',
    height : 0,
    border : 'none',
    backgroundSize : 'cover',
    backgroundPosition : 'center',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  imageZoom : {
    width : '100%',
  },
});